module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/rec-405f30117a39de53f68d7215ea9fce80.svg";